import { SiteUrl } from '@mirai-kids-monte/core/src/constants/SiteUrl';

export const PageUrl = {
  TOOL_RECOMMENDATION_ROOT: '/tool_recommendation/',
  TOOL_RECOMMENDATION_APP: '/tool_recommendation/app/',
  MONTE_CHAT_ROOT: '/monte_chat/',
  NURSERY_DX_SUPPORT_ROOT: '/lp/nursery_dx_support/',
  NURSERY_DX_DIAGNOSIS_EXTERNAL: 'https://app.spirinc.com/t/2aJF_HVpSedTYHp3IPUw4/as/ZYIwYE3lohZ-qtO-2xE1n/confirm',
  NURSERY_DX_GAS_ANSWER:
    'https://script.google.com/macros/s/AKfycbwRUk8QIQbdsdd8BC2o2K79adCmgBYmIW7m106r09J9-xy5i86by4QT_H7-A_qMa3X5/exec',
  MONTE_CHAT_EXTERNAL: process.env.NODE_ENV === 'production' ? `${SiteUrl.CHAT_WEB}/` : `${SiteUrl.LOCAL_CHAT}/`,
  MONTE_CHAT_TRY_EXTERNAL:
    process.env.NODE_ENV === 'production' ? `${SiteUrl.CHAT_WEB}/try` : `${SiteUrl.LOCAL_CHAT}/try`,
  BLOG_ROOT: '/blog/',
  BLOG_COURSES: '/blog/courses/',
  CONTACT: '/contact/',
  PRIVACY: '/privacy/',
  RECRUIT_TOP: '/recruit/',
  RECRUIT_ENTRY: '/recruit/entry/',
  MINNE_TOP: 'https://minne.com/@mirai-monte',
  LINE_ACCOUNT: 'https://lin.ee/8QLaXvY',
  INSTAGRAM_ACCOUNT: 'https://www.instagram.com/mirai.kids.monte.preschool/?hl=ja',
  GOOGLE_MAP_MONTE_SPACE: 'https://maps.app.goo.gl/dRrbK3VFjUc2qC1Z8',
  DAYCARE_TOP: '/daycare/',
  DAYCARE_POLICY: '/daycare/policy/',
  DAYCARE_PROGRAMS: '/daycare/programs/',
  DAYCARE_FEATURES: '/daycare/features/',
  DAYCARE_VOICE: '/daycare/voice/',
  DAYCARE_LIVING: '/daycare/living/',
  DAYCARE_TEACHERS: '/daycare/teachers/',
  DAYCARE_ADMISSION: '/daycare/admission/',
  DAYCARE_FACILITIES: '/daycare/facilities/',
  DAYCARE_CONTACT: '/daycare/contact/',
  DAYCARE_OUTLINE: '/daycare/outline/',
  DAYCARE_MONTE_TRIAL_CLASS: '/daycare/monte-trial-class/',
  DAYCARE_SATURDAY_HIROBA: '/daycare/saturday-hiroba/',
  DAYCARE_REFERRAL: '/daycare/referral/',
  DAYCARE_REFERRAL_TERMS: '/daycare/referral/terms/',
  CLASS_TOP: '/class/',
  TOP: '/',
  TV_LP: '/lp/tv/',
  DIAGNOSIS_ROOT: '/diagnosis/',
  DIAGNOSIS_RESULT: '/diagnosis/result/',
  DIAGNOSIS_REPORT_SAMPLE: '/diagnosis/report-sample/',
  DIAGNOSIS_REPORT_SUCCESS: '/diagnosis/report-success/',
  DIAGNOSIS_REPORT_TERMS: '/diagnosis/report-terms/',
} as const;

export type PageUrlType = (typeof PageUrl)[keyof typeof PageUrl];
